export const lines = {
  actions: {
    applyDiscount: 'Korting toepassen',
    duplicate: 'Kopiëren',
    editProduct: 'Product bewerken',
    removeDiscount: 'Korting verwijderen',
  },
  advantage: {
    buttonLabel: 'Je voordeel checken',
    label: 'Je voordeel dankzij Creative Shelter',
  },
  benefit: 'Voordeel',
  computerProgramAlert:
    'Factureer je een software-opdracht? Duid dan ‘Computerprogramma-prestatie’ aan. <faqLink>Meer weten over IT-opdrachten factureren?</faqLink>',
  creativeWork: {
    header: 'Soort prestatie',
    options: {
      CreativeComputer: {
        description: 'Je schrijft software of code voor je klant.',
        label: 'Computerprogramma-prestatie',
      },
      CreativeGeneral: {
        description: 'Je maakt nieuw, origineel werk voor je klant.',
        label: 'Creatieve prestatie',
      },
      CreativeReuse: {
        description: 'Je klant gebruikt bestaand werk van jou opnieuw of langer.',
        label: 'Hergebruik',
      },
      CreativeSubcontracting: {
        description: 'Je factureert creatief werk door dat een andere freelancer voor jou deed.',
        label: 'Onderaanneming',
      },
      NonCreative: {
        description: 'Je factureert kosten zoals materiaal, huur of verplaatsingen.',
        label: 'Geen creatieve prestatie',
      },
    },
    placeholder: 'Creatief werk?',
  },
  description: {
    header: 'Beschrijving',
    placeholder: 'Beschrijving',
    placeholderProduct: 'Extra informatie',
  },
  discount: {
    free: 'Gratis',
    header: 'Korting',
  },
  discountType: {
    flatRate: '€',
    percentage: '%',
  },
  lineTotal: {
    header: 'Totaal',
  },
  new: {
    invoiceLine: 'Factuurlijn toevoegen',
    photoAlbum: 'Fotoalbum toevoegen',
    photoAlbumLine: 'Fotoalbumlijn toevoegen',
    product: 'Product toevoegen',
    productTooltip:
      'Ontdek <a href="https://knowledge.creativeshelter.be/producten-wat-zijn-ze-en-hoe-gebruik-je-ze" target="_blank">hier</a> wat producten zijn!',
    quotationLine: 'Offertelijn toevoegen',
    textLine: 'Tekstregel toevoegen',
  },
  photoAlbum: {
    deleteDialog: {
      description: 'Ben je zeker dat je de sectie ‘fotoalbum’ wilt verwijderen? Dit verwijdert ook alle lijnen in deze sectie.',
      title: 'Fotoalbum verwijderen',
    },
    description: 'Voeg hier alle factuurlijnen toe die betrekking hebben op het fotoalbum.',
    tag: '6% btw',
    tagTooltip: 'Alle lijnen onder de sectie fotoalbum worden gefactureerd aan 6% btw.',
    title: 'Fotoalbum',
  },
  price: {
    header: 'Prijs (excl. btw)',
    productNotSyncTooltip: 'De prijs van je factuurlijn wijkt af van je productprijs. Door hier te klikken, gebruik je je productprijs.',
  },
  productName: {
    label: 'Product',
    tooltip:
      'Deze lijn is gebaseerd op een product. Je kan ze aanpassen, maar wijzigingen worden alleen op je factuur opgeslagen, niet in je product.',
  },
  quantity: {
    header: 'Aantal',
  },
  subtotal: 'Subtotaal',
  textLine: 'Tekstregel',
  total: 'Totaal',
  totalVat: 'Totaal btw',
  units: {
    characters_one: 'Teken',
    characters_other: 'Tekens',
    days_one: 'Dag',
    days_other: 'Dagen',
    halfDays_one: 'Halve dag',
    halfDays_other: 'Halve dagen',
    hours_one: 'Uur',
    hours_other: 'Uren',
    kilometers: 'Km',
    none: '—',
    placeholder: 'Selecteer',
    words_one: 'Woord',
    words_other: 'Woorden',
  },
  vat: {
    header: 'Btw',
  },
  vatExported: 'Export',
  vatPercentage: 'Btw ({{ percentage }}%)',
  vatRegime: {
    exceptionallyExempt: 'Btw-vrijgesteld',
    export: 'Btw export',
    shifted: 'Btw verlegd',
  },
  vatShifted: 'Btw verlegd',
  vatTooltip:
    'Op de factuur naar je klant rekenen we altijd btw, ongeacht je btw-statuut, omdat Creative Shelter een btw-plichtige onderneming is. <a href="https://knowledge.creativeshelter.be/wat-is-de-btw-vrijstellingsregeling-en-bestaan-er-nog-andere-regelingen" target="_blank">Lees er hier meer over!</a>',
};
